import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import { urls } from "utils-lib/builds"
import {
  GET_CANCEL_SERVICE_PRICING_FULFILLED,
  GET_CANCEL_SERVICE_PRICING_PENDING,
  GET_CANCEL_SERVICE_PRICING_FAILED,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"

export const pendingAC = () => ({
  type: GET_CANCEL_SERVICE_PRICING_PENDING,
})

export const failedAC = () => ({
  type: GET_CANCEL_SERVICE_PRICING_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_CANCEL_SERVICE_PRICING_FULFILLED,
  payload: data,
})

/**
 * Fetches bulk pickup pricing information.
 * @param {Object} params - The parameters for the action.
 * @param {string} params.customerId - The ID of the customer.
 * @param {Object} params.payload - The payload data to be sent with the request.
 * @returns {Function} A thunk action that dispatches the appropriate actions based on the API response.
 */
export const getCancelServicePricing =
  (
    customerId,
    cancelService = false,
    LDFFReleaseEligiblityEntryMywmDashboard = false,
  ) =>
  (dispatch, getState) => {
    dispatch(pendingAC())

    const api = `CANCEL_SERVICE_PRICING`
    const franMuniCategory = `FRAN/MUNI`
    const apiKey = get(urls, `apiKey.USER[${api}]`, ``)

    const template = URITemplate(urls.url[api])

    const state = getState()
    const category = LDFFReleaseEligiblityEntryMywmDashboard
      ? get(state, `cancelService.cancelServiceEligibility.data.category`, "")
      : get(state, `cancelService.cancelServiceEligibility.  category`, "")
    const isFranMuni = category === franMuniCategory
    const updatedPayload =
      !isEmpty(category) && isFranMuni && cancelService
        ? { isEcommFranMuniCustomer: true }
        : {}

    const url = template.expand({
      lang: get(state, `siteLanguage.language`, ``),
      userId: get(state, `userAccount.userDetails.userId`, ``),
      customerId,
      eligibilityId: LDFFReleaseEligiblityEntryMywmDashboard
        ? get(
            state,
            `cancelService.cancelServiceEligibility.data.eligibilityId`,
            ``,
          )
        : get(
            state,
            `cancelService.cancelServiceEligibility.eligibilityId`,
            ``,
          ),
    })

    return getTokenAction(dispatch, getState).then((token) => {
      const config = {
        headers: {
          apiKey,
          oktaToken: token.accessToken,
        },
        ...(cancelService
          ? { params: updatedPayload }
          : { data: updatedPayload }),
      }

      return axios(url, config)
        .then((response) => {
          dispatch(fulfilledAC(response.data))
          return response.data
        })
        .catch(() => {
          dispatch(failedAC())
        })
    })
  }
